import { StyleSheet } from 'react-native'
const useStyles = (theme, isTablet, isDesktop, hasLabel) => StyleSheet.create({
  cardStyle: {
    width: '100%',
    paddingTop: isDesktop ? 10 : hasLabel ? 25 : 10,
    paddingBottom: isDesktop ? 10 : hasLabel ? 25 : 10,
    paddingLeft: 10,
    paddingRight: 10,
    position: 'relative',
    flexDirection: 'row',
    backgroundColor: theme.CARD_BACKGROUND,
    marginVertical: 5,
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: 5,
    display: 'flex',
    alignItems: isTablet ? 'center' : 'flex-start',
    zIndex: 10,
    minHeight: 85,
    justifyContent: 'center'
  },
  hotOfferCard: {
    borderLeftColor: theme.RED_ORANGE,
    borderLeftWidth: 4
  },
  marked: {
    width: 3,
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5
  },
  iconContainer: {
    width: isTablet ? 30 : 20,
    height: isTablet ? 30 : 20,
    borderRadius: 100,
    backgroundColor: theme.GALLERY,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: isTablet ? 0 : 15,
    marginRight: isTablet ? 15 : 0
  },
  hotOffer: {
    backgroundColor: 'transparent',
    marginLeft: 15
  },
  status: {
    width: isTablet ? 80 : 'auto',
    alignItems: 'center',
    borderRadius: isTablet ? 10 : 3,
    paddingHorizontal: 6,
    paddingVertical: isTablet ? 0 : 3,
    marginBottom: !isTablet ? 10 : 0,
    position: isTablet ? 'absolute' : 'relative',
    top: 5,
    left: 10
  },
  number: {
    marginLeft: isTablet ? 20 : 0,
    marginBottom: isTablet ? 0 : 5,
    flexDirection: 'column',
    alignItems: isTablet ? 'flex-start' : 'flex-end',
    width: isDesktop ? 130 : 'auto',
    justifyContent: isDesktop ? 'space-between' : 'flex-start'
  },
  menuOptions: {
    width: isTablet ? 30 : 25,
    height: isTablet ? 30 : 25,
    borderRadius: 100,
    backgroundColor: theme.GALLERY,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: isTablet ? 0 : 15,
    marginRight: isTablet ? 15 : 0
  },
  Text: {
    width: 100,
    textAlign: isTablet ? 'left' : 'right',
    marginBottom: 0,
    marginLeft: isTablet ? 10 : 0
  },
  location: {
    flex: isDesktop ? 4 : 1
  },
  information: {
    flex: isDesktop ? 3 : isTablet ? 2 : 1,
    flexDirection: isTablet ? 'row' : 'column',
    width: isTablet ? 'auto' : 120,
    alignItems: isTablet ? 'center' : 'flex-end',
    justifyContent: 'space-between'
  },
  chips: {
    paddingVertical: 3,
    paddingHorizontal: 8,
    backgroundColor: theme.POLAR,
    borderRadius: 100,
    marginRight: 10,
    marginBottom: 5,
    width: 65
  },
  detail: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  selected: {
    borderWidth: 2,
    borderColor: theme.BUNKER
  }
})

export default useStyles
